// extracted by mini-css-extract-plugin
export default {"container":"Application_container__pJ2X9","imgBox":"Application_imgBox__U35qL","img":"Application_img__SVhFG","confirm":"Application_confirm__tNLwF"};